(function(){
  "use strict";
  async function token(){
    if(typeof window.hofGetSupabaseAccessToken==="function") return await window.hofGetSupabaseAccessToken();
    if(window.HallOfFanAuth && typeof window.HallOfFanAuth.getAccessToken==="function") return await window.HallOfFanAuth.getAccessToken();
    if(window.supabase && window.supabase.auth && typeof window.supabase.auth.getSession==="function"){
      const r=await window.supabase.auth.getSession(); return r && r.data && r.data.session && r.data.session.access_token || null;
    }
    return null;
  }
  function headers(cfg, accessToken){
    const h={"apikey":cfg.publishableKey,"Content-Type":"application/json"};
    if(accessToken) h.Authorization="Bearer "+accessToken;
    return h;
  }
  async function rpc(cfg, fn, body, accessToken){
    const r=await fetch(cfg.url+"/rest/v1/rpc/"+fn,{method:"POST",headers:headers(cfg,accessToken),body:JSON.stringify(body||{})});
    if(!r.ok) throw new Error((await r.text())||("Request failed "+r.status));
    const ct=r.headers.get("content-type")||""; return ct.includes("application/json")?r.json():r.text();
  }
  async function getCharacterAsset(opts){
    const cfg=opts.config||window.HOF_CHARACTER_CONFIG;
    if(!cfg) throw new Error("HallOfFan character config is missing");
    let url=await rpc(cfg,"halloffan_get_character_asset",{p_character_id:opts.characterId,p_pose_key:opts.poseKey},null);
    if(url) return url;
    const accessToken=opts.accessToken||await token();
    if(accessToken){
      const r=await fetch(cfg.url+"/functions/v1/halloffan-render-character",{
        method:"POST",headers:headers(cfg,accessToken),body:JSON.stringify({character_id:opts.characterId,pose_key:opts.poseKey})
      });
      const data=await r.json();
      if(r.ok && data.asset_url) return data.asset_url;
      if(!r.ok && opts.throwOnMissing) throw new Error(data.error||"Character pose is not generated");
    }
    return null;
  }
  window.HallOfFanCharacters={getAccessToken:token,getCharacterAsset:getCharacterAsset};
})();
